import '../src/assets/styles/application.scss'
import WebpackerReact from 'webpacker-react'
import Form from './../src/components/forms/Form/Form.jsx'

WebpackerReact.setup({ Form })
